module.exports = __webpack_public_path__ + "static/media/PZAP-USDC.7774ec35.png";